import { initReactI18next } from "react-i18next";
import i18Next from "i18next";
import detector from "i18next-browser-languagedetector";

export const defaultLang = "it";

export const options = {
  // language to use if translations in user language are not available.
  fallbackLng: defaultLang,
  interpolation: {
    escapeValue: false, // we do not use keys in form messages.welcome
  },
  pluralSeparator: "_",
  updateMissing: true,
  react: {
    wait: true,
    transSupportBasicHtmlNodes: false,
  },
};

i18Next.use(detector).use(initReactI18next); // passes i18n down to react-i18next

if (typeof window !== "undefined") {
  (window as any).i18n = i18Next;
}

export const i18n = i18Next;
